import React, { useState } from 'react';
import { Box, TextField } from '@mui/material'; 

interface IListingInteractionTypesDescriptionCellProps {
  description: string;
  index: number;
  onDescriptionChange: (index: number, newDescription: string) => void;
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const ListingInteractionTypesDescriptionCell: React.FC<IListingInteractionTypesDescriptionCellProps> = ({ description: initialDescr, index, onDescriptionChange, onFocus }) => {
  const [description, setDescription] = useState<string>(initialDescr);
  
  const handleBlur = () => {
    onDescriptionChange(index, description);
  };

  return (
    <Box>
      <TextField
        fullWidth
        placeholder="Listing Interaction Description"
        size="small"
        value={description ?? ''}
        onChange={event => setDescription(event.target.value)}
        onBlur={handleBlur}
        onFocus={onFocus}
      />
    </Box>
  );
};
